import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController, ModalController } from 'ionic-angular';

import { Notes, Dokumen, HelperMyRadiant, User } from '@providers/index';
import { FormNotePage, DetailImagePage } from '../'

@Component({
  selector: 'page-notes',
  templateUrl: 'page.html'
})
export class NotesPage {

  notes : any ;
  project:any = {};
  loading:any;
  img_url='';
  can_delete = false;
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public notesApi: Notes,
    public docApi: Dokumen,
    public helper : HelperMyRadiant,
    public userApi : User
  ) {
    this.project = this.navParams.get('project');
    this.img_url = this.docApi.file_url;
    if (this.userApi.akses.delete_notes_project) {
      this.can_delete = true;
    }
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  ionViewWillEnter(){
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    this.showLoading();
    let params = {
      project_id : this.project.id
    }
    this.notesApi.get(params).subscribe((resp:any) => {
      this.notes = resp.data;
      this.loading.dismiss();
    });
  }

  
  detailImage(rec : any = {}){
    let detailModal = this.modalCtrl.create(DetailImagePage,{
      url_image : this.img_url+rec.generated_name,
      detail : rec
    });
    detailModal.present();
  }
  
  add() {
    this.navCtrl.push(FormNotePage, {
      project: this.project
    });
  }

  deleteNote(note) {
    let params = {
      notes_id : note.id,
      tender_id : note.tender_id
    }

    let me = this,
      optionsSwal = {
      title: "Are you sure ?",   
      desc:"Once you delete notes, you cant't undo it. ",   
      icon: "",
      dangerMode: false,
      btnCancel: "Cancel",
      btnConfirm: "Delete",
    }
    this.helper.presentSwalConfirmation(optionsSwal, () => {
      me.loading = me.helper.showLoading("Please Wait...");
      me.notesApi.delete(params).subscribe((resp:any) => {        
        if (resp.success) {       
          try {
            me.loading.dismiss();
          } catch (error) {
          }
          me.helper.presentToast(resp.msg);
          me.getList();
        } else {
          me.helper.presentToast(resp.msg);
        }
      }, (err) => {
        try {
          me.loading.dismiss();
        } catch (error) {

        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/notes/page.ts